import validations from "./validations";
import getAuthorizationToken from "../authToken";
import startCase from "lodash/startCase";
import isArray from "lodash/isArray";;
import store from "@/store";
import menu from "./menu";

const GLOBAL_METHODS = {
  ...menu,
  ...validations,
  jenisKelamin(v) {
    const jk = [
      "Perempuan",
      "Laki-laki",
      "Tidak diketahui",
      "Tidak dapat ditentukan",
      "Tidak mengisi"
    ];
    return jk[v] || null;
  },
  rawAuthHeader: () => ({
    Authorization: getAuthorizationToken()
  }),
  entriesOpt({ f = null, arr = [] } = {}) {
    const o = [5, 10, 25, 50, 100];
    return (
      ((f, x) =>
        (f &&
          (isArray(f)
            ? x.filter(item => !f.includes(item))
            : x.filter(item => item !== f))) ||
        x)(
        f,
        (isArray(arr) &&
          [...new Set([...o, ...arr].flat())].sort((a, b) => a - b)) ||
          o
      )
      |> (_ =>
        _.map(item => ({
          value: item,
          text: item
        })))
    );
  },
  getLabelTable: val =>
    (val &&
      (val.label || val.key) &&
      (val.label ? val.label : val.key.split("_").join(" "))) ||
    val,
  generateFieldList({ field = null }) {
    const { getLabelTable } = this;
    return (
      (field &&
        isArray(field) &&
        field.map(item => ({
          key: (item.key && item.key) || item,
          label: startCase(getLabelTable(item)),
          sortable: item.sortable || false,
          searchable: item.searchable || false,
          ...item
        }))) ||
      []
    );
  },
  setSearchableAndSortableFieldList({
    field = null,
    customFunc = val => Boolean(/(actions|action)\b/gi.test(val) ? !1 : 1)
  }) {
    return (
      (field &&
        isArray(field) &&
        (field
          |> (_ =>
            _.map(item => ({
              ...item,
              searchable: customFunc(item.key || item),
              sortable: customFunc(item.key || item)
            }))))) ||
      []
    );
  },
  isMobile() {
    /* eslint-disable */
    var check = false;
    (function(a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  },
  isMobileTab() {
    var check = false;
    (function(a) {
      if (/Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(a)) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  },
  async cekPaketNolock() {
    let is_subskripsi = this.$route.name == 'subskripsi' ? '&page=subskripsi&nolock' : '&nolock';
    try {
      const res = await this.$axios.get(
        `cekPaket?klinik_id=${store.state.klinikId}${is_subskripsi}`
      );

      const dataPaket = res.data.detail_paket
      this.$root.$emit('updatePaket', dataPaket);

      if(res.data.version) {
        this.$root.$emit('app_version', res.data.version);
      }
      
      if (/telah otomatis aktif/.test(res.data.message.toLowerCase())) {
        let glue = res.data.message && res.data.message_addon ? '<br><br>' : '';
        let msg = `${res.data.message} ${glue} ${res.data.message_addon}`;

        return this.$swal({
          html: msg,
          showCancelButton: false,
          confirmButtonText: "OK",
          type: "success",
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then(val => {
          // window.location.reload(true);
        })
      }
    } catch (err) {
      // console.log(err);
    }
  },
  async cekPaket() {
    let is_subskripsi = this.$route.name == 'subskripsi' ? '&page=subskripsi' : '';
    try {
      const res = await this.$axios.get(
        `cekPaket?klinik_id=${store.state.klinikId}${is_subskripsi}`
      );

      const dataPaket = res.data.detail_paket
      this.$root.$emit('updatePaket', dataPaket);

      if(res.data.version) {
        this.$root.$emit('app_version', res.data.version);
      }
      
      if (res.data.message || res.data.message_addon) {
        let glue = res.data.message && res.data.message_addon ? '<br><br>' : '';
        let msg = `${res.data.message} ${glue} ${res.data.message_addon}`;
        let isPic = this.getRolesName.includes('pic_cabang');

        this.$swal({
          html: msg,
          showCancelButton: false,
          confirmButtonText: "OK",
          type: "warning",
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then(val => {

          if(res.data.data.goto_subskripsi && isPic) {
            this.$router.push('/klinik/subskripsi');
          }else{
            this.$router.push('/');
          }
        })

        return false;
      }
      return true;
    } catch (err) {
      // console.log(err);
    }
  },
  checkValueData(val) {
    let status = false;
    if (val && typeof val == 'object' && val != undefined) status = true;
    if (val && val != "" && val != null && val != undefined) status = true;
    return status;
  },
  async fetchAlergiJenis(jenis = '00') {
    let result = [];
    try {
      const res = await this.$axios.get(`bpjs/alergi/jenis/${jenis}?klinik_id=${store.state.klinikId}`);
      const { metaData, response } = res.data;
      if (metaData.code == 200 && response) result = response.list.map(v => ({value: v.kdAlergi, label: v.nmAlergi}));
    } catch (err) {
      // console.warn(err)
    }
    return result;
  },
  checkPoliGigi(poli) {
    if (this.checkValueData(poli)) {
      if (poli.toLowerCase().includes('gigi') || poli.toLowerCase().includes('dental')) return true;
    }
    return false;
  },
  goNotFound() {
    this.$router.replace('/not-found');
  },
};

export default GLOBAL_METHODS;
